import { useEffect, useState } from 'react';

/**
 * Subscribes to browser online/offline events. Initial state is seeded from
 * <c>navigator.onLine</c>. Used by the offline banner and by any component
 * that wants to degrade gracefully when the network is unreachable.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return online;
}
